<template>
<div class="chapter">
<div class="inner_page">
<p class="C96"><a id="page_ix">A NOTE ON THE TITLE</a></p><a id="page_ix">
<p class="C76">ITALO CALVINO SPENT THE BETTER PART OF 1985 PREPARING to deliver the Charles Eliot Norton Lectures at Harvard. The great Italian novelist died before he could present his talks, and though he’d completed only five of the six lectures he had planned, the work was published the following year under its intended title, <em>Six Memos for the Next Millennium</em>.</p>
<p class="P23">According to the Hebrew calendar—which, unlike its Gregorian counterpart, moves in only one direction—the current year is 5776. In other words: we’re deep into the sixth millennium.</p>
<p class="P23">The Talmud was closed, by its editors, around 4235 (475 <span class="small">CE</span>), and with Calvino in mind—his playful erudition has long been a beacon for me—I’ve come to think of the stories I discuss in this book as memos from an unnamed writer working in the hinge-time between the fourth and fifth millennia.</p>
<p class="P23">Hence: <em>Six Memos from the Last Millennium</em>.</p>
<p class="P23">And in deference to the tradition created unintentionally by Calvino—a cosmicomic baker’s half-dozen in reverse: five pieces for the price of six—I’ve included only five chapters here.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_A_Note_on_the_Title.vue?367d7b22